import { useState } from 'react';

const useDraftSelections = ({ onChange, selectedItem, setSelectedItems, enableMultiSelect, allowDraftSelections, triggerRef }) => {
    const [changes, setChanges] = useState();
    const [selectionsChanged, setSelectionsChanged] = useState(false);
    // hook methods would be needed for draft selections only,
    // for rest of the cases, send back the original onchange as is
    if (!allowDraftSelections) {
        return {
            onRealChange: onChange,
            draftSelectionsAllowed: false
        };
    }
    const draftSelectionsAllowed = enableMultiSelect && allowDraftSelections;
    // set a local state if any selections are changed
    /* istanbul ignore next */
    const selectionsUpdated = (changes) => {
        const { selectedItems } = changes;
        const currentItems = selectedItem ? [selectedItem].flat() : [];
        const currentValues = currentItems.map((item) => item.value);
        const selectedValues = selectedItems.map((item) => item.value);
        if (currentValues.length === selectedValues.length &&
            currentValues.filter((currentValue) => !selectedValues.includes(currentValue)).length === 0) {
            setSelectionsChanged(false);
        }
        else {
            setSelectionsChanged(true);
        }
    };
    // event handler for internal state maintenance
    const onDraftChange = (changes) => {
        // with every selection, store the latest Changes object
        setChanges(changes);
        // keep the local state up to date
        setSelectedItems(changes.selectedItems);
        selectionsUpdated(changes);
    };
    // proxy event handler for external change event
    const onRealChange = (changes) => {
        setSelectedItems(changes.selectedItems);
        // call the external onChange event handler
        onChange(changes);
    };
    const applyChanges = () => {
        var _a;
        /* istanbul ignore next */
        if (changes) {
            setSelectedItems(changes.selectedItems);
            // trigger the external change event with all the selections
            onChange(changes);
            setChanges(undefined); // discard the Changes object
        }
        setSelectionsChanged(false);
        /* istanbul ignore next */
        if (triggerRef) {
            (_a = triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    const discardChanges = () => {
        var _a;
        // discard draft changes, reset to last applied selection
        setSelectedItems((selectedItem ? [selectedItem].flat() : []));
        setChanges(undefined); // discard the Changes object
        setSelectionsChanged(false);
        /* istanbul ignore next */
        if (triggerRef) {
            (_a = triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    return {
        onDraftChange,
        onRealChange,
        applyChanges,
        discardChanges,
        draftSelectionsAllowed,
        selectionsChanged
    };
};

export { useDraftSelections };
//# sourceMappingURL=useDraftSelections.esm.js.map
